import styled from 'styled-components';
import { style as profile, style } from '../../../style';

export const HeaderDialog = styled.div`
  border-top: 1px, solid, ${profile.inpuStyle.colorInput};
  height: 5px;
  background-color: ${profile.inpuStyle.colorInput};
  border-radius: 5px 5px 0 0;
`;
